import { useState } from "react"; 
import Rating from "react-rating"; 
import { query as q } from 'faunadb'; 

import PineappleNoFill from './pineapple-nofill.svg'; 
import PineappleFill from './pineapple-fill.svg'; 

export default function AddQuoteForm({ cookies, cookiesPermission, db_client }) {
    const [quote, setQuote] = useState(''); 
    const [rating, setRating] = useState(0); 

    const handleAddQuote = e => {
        if (!quote || !cookiesPermission) return; 
        e.preventDefault(); 

        let newRating = {}; 
        newRating[cookies.guid] = rating; 
    
        db_client.query(
          q.Create(
            q.Collection('suggestions'), 
            { data: {
              author: cookies.guid, 
              quote: quote, 
              ratings: rating ? newRating : {}, 
              ratingAvg: rating ? rating : 0 
            } }
          ) 
        ).then(ret => {
          console.log(ret); 
          // updateRating(ret.ref.id, 5); 
        }).catch(err => console.log(err)); 

        setQuote(''); 
        setRating(0); 
    }; 

    return (
        <div className="flex flex-col items-start justify-center gap-3 rounded-lg">
            <div className="form-control w-full max-w-xs">
                <label className="label"><span className="label-text font-semibold">Quote</span></label> 
                <textarea className="textarea textarea-bordered border-2" placeholder="Enter your quote here..." value={quote} onChange={e => setQuote(e.target.value)}></textarea> 
            </div>
            <div className="form-control w-full max-w-xs">
                <label className="label mb-2"><span className="label-text font-semibold">Add the first rating? (optional)</span></label> 
                <Rating className="hover:scale-105 transition-transform ml-3 mb-10" emptySymbol={<div className="w-7" style={{content: `url(${PineappleNoFill})`}} />} fullSymbol={<div className="w-7" style={{content: `url(${PineappleFill})`}} />} fractions={2} initialRating={rating} onChange={val => setRating(val)} /> 
            </div>
            <button className={`btn ${(cookiesPermission && quote !== "") ? "btn-primary" : "disabled"} self-end`} disabled={!cookiesPermission || quote === ""} onClick={handleAddQuote}>Add Quote</button> 
            { !cookiesPermission ? <p className="text-xs text-gray-500 italic">* You must have cookies enabled to add a quote.</p> : "" } 
        </div> 
    ); 
}